// extracted by mini-css-extract-plugin
export default {"scrollToTop":"ScrollToTopButton_scrollToTop__9PGr+","iconPosition":"ScrollToTopButton_iconPosition__Py8Bu"};